import React from 'react';
import { Error } from 'components/theme/Form';
import { FieldErrors } from 'react-hook-form';

interface ErrorMessageProps {
  errors?: FieldErrors;
  name: string;
  message: string;
  style?: React.CSSProperties;
}

const ErrorMessage = ({ errors, name, message, style }: ErrorMessageProps) => {
  if (!errors || !errors?.[name]) return null;
  return (
    <Error
      id={`${name}-error`}
      role="alert"
      aria-live="assertive"
      style={style}
    >
      {message}
    </Error>
  );
};

export default ErrorMessage;
